import { v4 as uuidv4 } from "uuid";

export default defineNuxtPlugin((nuxtApp) => {
  const deviceIdCookie = useCookie("deviceId", {
    maxAge: 365 * 24 * 60 * 60, // 一年有效期
    path: "/",
  });

  // 如果没有 deviceId，生成一个临时的
  if (!deviceIdCookie.value) {
    deviceIdCookie.value = uuidv4();
  }

  // 将 deviceId 存储到 nuxtApp 上下文中，供其他地方使用
  nuxtApp.provide("deviceId", deviceIdCookie.value);

  // 获取并设置 adid
  const route = useRoute();
  const adid = route.query.adid;
  if (adid) {
    // 把 adid 加入 cookie 中，服务端和客户端都能访问
    const adidCookie = useCookie("adid", {
      maxAge: 60 * 60 * 24 * 365, // 1 年
    });
    adidCookie.value = adid as string;
  }

  // 带推广码进入时，标记本 tab 用于注册归因（sessionStorage 关闭 tab 后消失）
  const promoCode = route.query.promotion_code;
  if (promoCode && import.meta.client) {
    sessionStorage.setItem(PROMO_CODE_KEY, promoCode as string);
  }

  // 第一次进入页面的时候获取refer，然后存入session中
  if (import.meta.client) {
    // 获取并存储 referrer
    const referrer = document.referrer;
    if (!sessionStorage.getItem("initialReferrer")) {
      sessionStorage.setItem("initialReferrer", referrer);
    }
  }
});
